import React from 'react';
import { Route } from 'react-router-dom';
import routes from '../library/Routes';
import apiConfig from '../infrastructure/Config';

const bizRoutePaths = [
  routes.faq(),
  routes.landings.skiSchool(),
  routes.landings.acting(),
  routes.landings.language(),
  routes.landings.fitness(),
  routes.landings.music(),
  routes.landings.tutoring(),
  routes.landings.preschool(),
  routes.landings.childcare(),
  routes.landings.crossfit(),
  routes.business(),
  routes.businessWithCulture(),
  routes.prices(),
  routes.pricesWithCulture(),
  routes.aboutUs(),
];

export const renderBizLandingRoutes = (): React.ReactNode[] =>
  bizRoutePaths.map((path, index) => (
    <Route
      key={index}
      exact
      path={path}
      component={(): null => {
        window.location.href = 'https://landing.voopty.com.ua';
        return null;
      }}
    />
  ));

export const renderWWWRedirects = (): React.ReactNode[] =>
  bizRoutePaths.map((path, index) => (
    <Route
      key={index}
      exact
      path={path}
      component={(): null => {
        window.location.href = `${apiConfig.rootUrl['en_US']}${window.location.pathname}`;
        return null;
      }}
    />
  ));
